export default{
  accountInfo: (state) => state.accountInfo,
  logged: (state) => state.logged
}



// WEBPACK FOOTER //
// ./src/components/account/store/getters.js